import "./Estate.module.css";
import Header from "@/reusable_sections/Header";
import ACanvasForYourVision from "./sections/ACanvasForYourVision";
import TheCeremonyGarden from "./sections/TheCeremonyGarden";
import TheGrandBallroom from "./sections/TheGrandBallroom";
import Footer from "@/reusable_sections/Footer";
export default function EstatePage() {
  return <div>
      <Header />
      <ACanvasForYourVision />
      <TheCeremonyGarden />
      <TheGrandBallroom />
      <Footer />
    </div>;
}